var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AlertController, ModalController, Platform } from "@ionic/angular";
import { SharedRoutes } from "shared/lib/common/enums";
import { AdminPage as SharedAdminPage } from "shared/lib/v1/pages";
import { ConfigService, PosConnectionService, ToastService, TranslateService, UserService, InactivityService, RoutingService, EnvironmentService, } from "shared/lib/common/services";
import { RevenueDatePage } from "../revenue-date/revenue-date.page";
import { AdminService } from "shared/lib/v2/services";
var AdminPage = /** @class */ (function (_super) {
    __extends(AdminPage, _super);
    function AdminPage(_translate, _platform, _admin, _user, _toast, _posConnectionService, _alert, _config, modal, inactivity, _routing, _environment) {
        var _this = _super.call(this, _translate, _platform, _admin, _user, _config, _toast, _routing, _environment) || this;
        _this._translate = _translate;
        _this._platform = _platform;
        _this._admin = _admin;
        _this._user = _user;
        _this._toast = _toast;
        _this._posConnectionService = _posConnectionService;
        _this._alert = _alert;
        _this._config = _config;
        _this.modal = modal;
        _this.inactivity = inactivity;
        _this._routing = _routing;
        _this._environment = _environment;
        return _this;
    }
    AdminPage.prototype.ionViewWillEnter = function () {
        this.manualAllowed = this._config.getAllowedManualPoints();
        this.revenueModule = this._config.getMountingConfig().posMode !== "SER";
        this.bookPointModule = this._config.getMountingConfig().posMode === "SER";
    };
    AdminPage.prototype.ionViewWillLeave = function () {
        this.loading = false;
        this.inactivity.resetTimer();
    };
    AdminPage.prototype.arts = function (queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            var date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dateModal()];
                    case 1:
                        date = _a.sent();
                        if (date && queryParams.type === "earn") {
                            queryParams = { type: "earn", totalRevenue: queryParams.totalRevenue, totalPoints: queryParams.totalPoints, date: date };
                            this._routing.goForward([SharedRoutes.qrScanner], {
                                queryParams: queryParams,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminPage.prototype.addPoints = function (manualPoints) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams;
            return __generator(this, function (_a) {
                queryParams = { type: "earn", manualPoints: manualPoints };
                this._routing.goForward([SharedRoutes.qrScanner], {
                    queryParams: queryParams,
                });
                return [2 /*return*/];
            });
        });
    };
    AdminPage.prototype.dateModal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modal.create({
                            component: RevenueDatePage,
                            backdropDismiss: false,
                            cssClass: "modal",
                        })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, modal.onDidDismiss()];
                    case 3:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return AdminPage;
}(SharedAdminPage));
export { AdminPage };
